import {
	flexRender,
	getCoreRowModel,
	getExpandedRowModel,
	getFilteredRowModel,
	getGroupedRowModel,
	useReactTable
} from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow
} from '@/components/Table';

export function DataTable({
	columns,
	data,
	// manualGrouping,
	state,
	onGlobalFilterChange,
	onRowSelectionChange,
	onGroupingChange,
	ready = true,
	className,
	tableCellClassName,
	meta,
	isTablet
}) {
	const { t } = useTranslation();

	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		getGroupedRowModel: getGroupedRowModel(),
		getExpandedRowModel: getExpandedRowModel(),
		groupedColumnMode: 'remove',
		state,
		onGlobalFilterChange,
		onRowSelectionChange,
		onGroupingChange,
		meta
	});

	return (
		<Table
			className={
				(table.getIsSomePageRowsSelected() ||
					table.getIsAllPageRowsSelected()) &&
				className
			}
		>
			{isTablet ? (
				<TableHeader className={tableCellClassName}>
					<TableRow>
						<TableHead>
							{t('users.title')}
							<th />
						</TableHead>
					</TableRow>
				</TableHeader>
			) : (
				<TableHeader className={tableCellClassName}>
					{table.getHeaderGroups().map(headerGroup => {
						return (
							<TableRow key={headerGroup.id}>
								{headerGroup.headers.map(header => {
									return !header.column.columnDef.header ? (
										<th key={header.id} />
									) : (
										<TableHead key={header.id}>
											{header.isPlaceholder
												? null
												: flexRender(
														header.column.columnDef.header,
														header.getContext()
													)}
										</TableHead>
									);
								})}
							</TableRow>
						);
					})}
				</TableHeader>
			)}
			<TableBody>
				{table.getFilteredRowModel().rows?.length ? (
					table.getFilteredRowModel().rows.map(row => (
						<TableRow
							key={row.id}
							data-state={row.getIsSelected() && 'selected'}
						>
							{row.getVisibleCells().map(cell => (
								<TableCell key={cell.id} table={table}>
									{flexRender(
										cell.column.columnDef.cell,
										cell.getContext()
									)}
								</TableCell>
							))}
						</TableRow>
					))
				) : (
					<TableRow>
						<TableCell
							colSpan={columns.length}
							className="h-24 text-center"
						>
							<div className="m-auto">
								{ready && t('myDocuments.table.noResults')}
							</div>
						</TableCell>
					</TableRow>
				)}
			</TableBody>
		</Table>
	);
}
